export const RouteTable = {
  catalogDesign: "/design/catalog",
  cards: "/design/cards",
  layouts: "/design/layouts",
  productCatalogMapping: "/products/catalog-mapping",
};
